import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import {
  checkPoints,
  getData,
  getDatasetProgress,
  getDatasetUsed,
  getTuningUsedUsed,
  setIsSaveDraft,
  setIsSaved,
} from '../../features/aiBotSlice';
import {
  findTag,
  getOrganizationMembers,
  getTriggerBot,
} from '../../features/mainSlice';
import {
  getIntegration,
  getNextResource,
  getOrganization,
} from '../../features/organizationSlice';

function Initial({ children, setIsloading }) {
  const { orgId, id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const init = async () => {
      setIsloading(true);
      await Promise.all([
        dispatch(setIsSaved(false)),
        dispatch(setIsSaveDraft(false)),
        dispatch(getOrganization(orgId)),
        dispatch(getDatasetProgress(orgId, id)),
        dispatch(findTag(undefined, orgId)),
        dispatch(getIntegration(orgId)),
        dispatch(checkPoints(orgId)),
        dispatch(getNextResource(orgId)),
        dispatch(getDatasetUsed(orgId, id)),
        dispatch(getTuningUsedUsed(orgId, id)),
        dispatch(getTriggerBot(orgId)),
      ]);
      await dispatch(getData(orgId, id));
      await dispatch(getOrganizationMembers({ orgId, limit: 20 }));
      setIsloading(false);
    };

    init();
  }, []);

  return <>{children}</>;
}

export default Initial;
